import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import * as React from 'react';
export default {
  HeroLayout,
  React
};